import axios from '@/utils/axios';

const apiUrl = {
  queryRecordUrl: '/feishu_recharge/query_financial_governance_record',
  financialGovernanceUrl: '/feishu_recharge/financial_governance',
  financialGovernanceV2Url: '/feishu_recharge/financial_governance_v2',
  executeGovernanceUrl: '/feishu_recharge/execute_financial_governance',
  auditGovernanceUrl: '/feishu_recharge/audit_financial_governance',
  exportRecordUrl: '/feishu_recharge/export_financial_governance_record',
};

// 处理 BigInteger 精度丢失：在 JSON 解析前将大数字 ID 转为字符串
const bigIntTransform = [function (data) {
  if (typeof data === 'string') {
    data = data.replace(/"id"\s*:\s*(\d{16,})/g, '"id":"$1"');
  }
  return JSON.parse(data);
}];

// 查询资金治理记录
export function queryFinancialGovernanceRecord(params) {
  return axios.post(apiUrl.queryRecordUrl, params, { transformResponse: bigIntTransform });
}

// 执行资金治理（预计算/自动执行）
export function financialGovernance(params) {
  return axios.post(apiUrl.financialGovernanceUrl, params, { transformResponse: bigIntTransform });
}

// 执行单条/条件资金治理
export function executeFinancialGovernance(params) {
  return axios.post(apiUrl.executeGovernanceUrl, params, { transformResponse: bigIntTransform });
}

// 条件资金治理审核
export function auditFinancialGovernance(params) {
  return axios.post(apiUrl.auditGovernanceUrl, null, { params, transformResponse: bigIntTransform });
}

// 文件治理V2（上传Excel文件执行资金治理）
export function financialGovernanceV2(formData) {
  return axios.post(apiUrl.financialGovernanceV2Url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    transformResponse: bigIntTransform,
  });
}

// 导出资金治理记录
export function exportGovernanceRecord(params) {
  return axios.post(apiUrl.exportRecordUrl, params, { responseType: 'blob' });
}
